import Crud from '../components/CheckListItem/Crud'
import Add from '../components/CheckListItem/Add'

let routes = {
    path: '/checklistItems',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/checklistItems/add',
            name: 'Novo Item de Checklist',
            component: Add
        },
        {
            path: '/checklistItems/edit/:id?',
            name: 'Editar Item de Checklist',
            component: Add
        },
        {
            path: '/checklistItems',
            name: 'Itens de Checklist',
            component: Crud
        },
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/checklist-items.js